import React from 'react';
import { Box } from '@wix/design-system';
import { useHorizontalPullToLoad } from '../../hooks/useHorizontalPullToLoad';
import s from './BusinessNamesSection.scss';
export const BusinessNamesHorizontalScrollGrid = _ref => {
  let canLoadMore = _ref.canLoadMore,
    onLoadMore = _ref.onLoadMore,
    children = _ref.children;
  const _useHorizontalPullToL = useHorizontalPullToLoad({
      onTrigger: onLoadMore,
      enabled: canLoadMore,
      triggerAt: 80
    }),
    rootRef = _useHorizontalPullToL.rootRef,
    spacerRef = _useHorizontalPullToL.spacerRef;
  return /*#__PURE__*/React.createElement(Box, {
    ref: rootRef,
    className: s.hideScrollbar,
    display: "block",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    overscrollBehaviorX: "contain",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridAutoFlow: "column",
    gridTemplateRows: "repeat(2, auto)",
    gridAutoColumns: "230px",
    gap: "12px",
    paddingInlineStart: "16px"
  }, children, canLoadMore && /*#__PURE__*/React.createElement("div", {
    ref: spacerRef,
    className: s.pullSpacer,
    "aria-hidden": true
  })));
};
//# sourceMappingURL=BusinessNamesHorizontalScrollGrid.js.map